<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Grupos de Adicionais
        <v-spacer></v-spacer>
        <v-btn color="primary" to="/adicionais/novo">Novo Grupo</v-btn>
      </v-card-title>
      
      <v-data-table
        :headers="headers"
        :items="groups"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="$router.push(`/adicionais/${item.ID}/editar`)">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteGroup(item)">
                mdi-delete
            </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog de Confirmação -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline">Excluir Grupo</v-card-title>
        <v-card-text>Tem certeza que deseja remover o grupo <strong>{{ itemToDelete ? itemToDelete.NOME : '' }}</strong>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddonsIndex',
  data() {
    return {
      loading: false,
      groups: [],
      dialogDelete: false,
      itemToDelete: null,
      headers: [
        { text: 'ID', value: 'ID' },
        { text: 'Nome', value: 'NOME' },
        { text: 'Tipo', value: 'TIPO_ESCOLHA' },
        { text: 'Min/Max', value: 'min_max', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ]
    };
  },
  created() {
    this.fetchGroups();
  },
  methods: {
    async fetchGroups() {
      this.loading = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_LOCAL}/grupos-adicionais`);
        this.groups = response.data.map(g => ({
            ...g,
            min_max: `${g.QTD_MIN} / ${g.QTD_MAX}`
        }));
      } catch (error) {
        console.error(error);
        this.$root.$emit('open-snackbar-on-group', 'Erro ao carregar grupos');
      } finally {
        this.loading = false;
      }
    },
    
    deleteGroup(item) {
        this.itemToDelete = item;
        this.dialogDelete = true;
    },

    closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
            this.itemToDelete = null;
        });
    },

    async confirmDelete() {
        if (!this.itemToDelete) return;

        try {
            await axios.delete(`${process.env.VUE_APP_API_LOCAL}/grupos-adicionais/${this.itemToDelete.ID}`);
            this.fetchGroups();
            this.$root.$emit('open-snackbar-on-group', 'Grupo removido com sucesso');
        } catch (error) {
            console.error(error);
             this.$root.$emit('open-snackbar-on-group', 'Erro ao remover grupo');
        } finally {
            this.closeDelete();
        }
    }
  }
};
</script>
